module.exports = __webpack_public_path__ + "img/q4.db4b6670.png";